<template>
  <div>
    <transition>
      <div class="logout flexcenter">
        <div class="logout-dialog flexcenter">
          <div class="lbold font16">ログアウトします。よろしいですか？</div>
          <div class="flexcenter buttons">
            <button class="nobutton" type="button" @click="$emit('close')"><span class="notext">いいえ</span></button>
            <button class="yesbutton" type="button" @click="doLogout"><span class="yestext">はい</span></button>
          </div><!-- flexcenter buttons -->
        </div><!-- logout-dialog flexcenter -->
      </div><!-- logout flexcenter -->
    </transition>
  </div>
</template>

<script>
import common from '@/mixin/common';
import http from '@/mixin/http';

export default {
  name: 'logout',
  mixins: [
    common,
    http,
  ],
  created: function () {
    this.log("Logout start created");
  },
  mounted: function () {
    this.log("Logout start mounted");
    this.setBodyStylePosition(true);
  },
  beforeDestroy: function () {
    this.log("Logout start beforeDestroy");
    this.setBodyStylePosition(false);
  },
  methods: {
    /**
     * ログアウトAPI呼び出し
     */
    doLogout: function () {
      this.log("Logout start doLogout");
      var self = this;

      // ログアウトAPIを実行
      this.logout().then(function (response) {
        self.log("Logout logout result_code: " + response.result_code);
        self.goLogin();
      }).catch(function (err) {
        self.goLogin();
      });
    },
    /**
     * ログイン画面へ遷移
     */
    goLogin: function() {
      this.$router.replace({ name: 'Login' });
    },
  },
};
</script>

<style lang="scss">
@import 'src/assets/style/modal';
</style>



// WEBPACK FOOTER //
// Logout.vue?211833c4